import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=18069707&scoped=true&"
import script from "./Sites.vue?vue&type=script&lang=js&"
export * from "./Sites.vue?vue&type=script&lang=js&"
import style0 from "./Sites.vue?vue&type=style&index=0&id=18069707&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18069707",
  null
  
)

export default component.exports